export default "/images/vendor/flag-icon-css/flags/4x3/et.svg?cbe354bb4afa8afc62dabc80051f9577";